<script setup lang="ts">
import CiCampsiteMediaInfo from '@/components/CiCampsiteMedia/CiCampsiteMediaInfo.vue';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiCampsiteMediaVideoProps {
  item: any;
  selected?: boolean;
  showUser?: boolean;
}
const props = withDefaults(defineProps<CiCampsiteMediaVideoProps>(), {
  selected: false,
  showUser: true,
});
</script>

<template>
  <div :class="{ 'h-full bg-gray-10': !props.selected, 'bg-[#fbfbfb]': props.selected }">
    <div
      class="relative aspect-video size-full rounded"
      style="-webkit-mask-image: -webkit-radial-gradient(white, black)"
    >
      <div
        v-if="!props.selected"
        class="absolute left-0 top-0 z-10 size-full cursor-pointer"
      />
      <client-only>
        <iframe
          :src="`${props.item.embed_url}?rel=0`"
          class="absolute left-0 top-0 size-full"
          :class="{ absolute: !props.selected }"
          allowfullscreen
          title="video"
          loading="lazy"
        />
      </client-only>
    </div>

    <CiCampsiteMediaInfo
      v-if="props.selected"
      :item="props.item"
      :show-user="props.showUser"
    />
  </div>
</template>

<style></style>
